module.exports = __webpack_public_path__ + "img/input-right.c1d7e1b2.png";